<main class="check">
  <header [attr.id]="data.title">
    <h3 [class.error]="!data.isPassed">
      {{ data.title }}
    </h3>
  </header>
  <section
    class="check-cases"
    [class.border]="data.pumpRoomInstallationMain.isApplicable"
    [attr.id]="data.pumpRoomInstallationMain.title"
  >
    <mat-slide-toggle
      [color]="data.pumpRoomInstallationMain.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.pumpRoomInstallationMain.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        [class.error]="
          data.pumpRoomInstallationMain.isApplicable &&
          !data.pumpRoomInstallationMain.isPassed
        "
        >{{ data.pumpRoomInstallationMain.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.pumpRoomInstallationMain.isApplicable &&
        !data.pumpRoomInstallationMain.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.pumpRoomInstallationMain.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.pumpRoomInstallationMain.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.pumpRoomInstallationMain.certificateNumber"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.pumpRoomInstallationMain.reportReceived"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="data.waterReservoirInstallation.isApplicable"
    [attr.id]="data.waterReservoirInstallation.title"
  >
    <mat-slide-toggle
      [color]="data.waterReservoirInstallation.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.waterReservoirInstallation.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        [class.error]="
          data.waterReservoirInstallation.isApplicable &&
          !data.waterReservoirInstallation.isPassed
        "
        >{{ data.waterReservoirInstallation.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.waterReservoirInstallation.isApplicable &&
        !data.waterReservoirInstallation.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.waterReservoirInstallation.title }}
    </span>
    <div
      class="cases"
      *ngIf="data.waterReservoirInstallation.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.waterReservoirInstallation.totalInstalledWaterReservoirs
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.waterReservoirInstallation.waterReservoirVolumeAsDesigned
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterReservoirInstallation.reservoirMaterialType"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterReservoirInstallation.installedVortexPlate"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.waterReservoirInstallation.installedSurfingAndEmptyingPipes
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.waterReservoirInstallation.installedAccessHoleAndladder
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.waterReservoirInstallation.installedWaterRreservoirAltimeter
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterReservoirInstallation.isWaterReservoirFull"
      ></authority-labs-check-case>
    </div>
  </section>

  <div *ngIf="printPreview">
    <mat-card
      *ngFor="let item of data.pumps; let ind = index"
      class="mat-elevation-z4"
    >
      <mat-card-header>
        <mat-card-title>{{ tabName(ind) }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ng-container
          *ngTemplateOutlet="pumpTpl; context: { item: item, ind: ind }"
        ></ng-container>
      </mat-card-content>
    </mat-card>
  </div>
  <mat-tab-group
    class="mat-elevation-z4"
    [(selectedIndex)]="selectedTab"
    *ngIf="!printPreview"
  >
    <mat-tab *ngFor="let item of data.pumps; let ind = index">
      <ng-template mat-tab-label>
        <mat-icon class="fail" color="warn" *ngIf="!item.isPassed">
          priority_high
        </mat-icon>
        <span>{{ tabName(ind) }}</span>
      </ng-template>
      <ng-template matTabContent>
        <div [style.margin-right]="readonly || printPreview ? '45px' : '0'">
          <ng-container
            *ngTemplateOutlet="pumpTpl; context: { item: item, ind: ind }"
          ></ng-container>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</main>

<ng-template #pumpTpl let-item="item" let-ind="ind">
  <section
    class="check-cases"
    [class.border]="item.fireExtinguishingPumpsInstallation.isApplicable"
    [attr.id]="item.fireExtinguishingPumpsInstallation.title"
  >
    <mat-slide-toggle
      [color]="
        item.fireExtinguishingPumpsInstallation.isPassed ? 'primary' : 'warn'
      "
      [(ngModel)]="item.fireExtinguishingPumpsInstallation.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        [class.error]="
          item.fireExtinguishingPumpsInstallation.isApplicable &&
          !item.fireExtinguishingPumpsInstallation.isPassed
        "
        >{{ item.fireExtinguishingPumpsInstallation.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        item.fireExtinguishingPumpsInstallation.isApplicable &&
        !item.fireExtinguishingPumpsInstallation.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ item.fireExtinguishingPumpsInstallation.title }}
    </span>
    <div
      class="cases"
      *ngIf="
        item.fireExtinguishingPumpsInstallation.isApplicable;
        else notApplicable
      "
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.fireExtinguishingPumpsInstallation.waterSupplySource"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.fireExtinguishingPumpsInstallation.pumpPowerSupply"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.fireExtinguishingPumpsInstallation.pumpDetails"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.fireExtinguishingPumpsInstallation.commandPanelModel"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          item.fireExtinguishingPumpsInstallation
            .equipmentInstalledAccordingSpec
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.fireExtinguishingPumpsInstallation.airVents"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.fireExtinguishingPumpsInstallation.liquidity"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.fireExtinguishingPumpsInstallation.emergencyLighting"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.fireExtinguishingPumpsInstallation.floodDetection"
      ></authority-labs-check-case>
      <authority-labs-check-water-characteristics-case
        [inspection]="
          item.fireExtinguishingPumpsInstallation.jockeyPumpInPressure
        "
        [characteristics]="characteristics"
        [printPreview]="printPreview"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-water-characteristics-case
        [inspection]="
          item.fireExtinguishingPumpsInstallation.jockeyPumpOutPressure
        "
        [characteristics]="characteristics"
        [printPreview]="printPreview"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-water-characteristics-case
        [inspection]="
          item.fireExtinguishingPumpsInstallation.dieselOrElectricPumpInPressure
        "
        [characteristics]="characteristics"
        [printPreview]="printPreview"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-check-water-characteristics-case>
      <authority-labs-check-water-characteristics-case
        [inspection]="
          item.fireExtinguishingPumpsInstallation
            .dieselOrElectricPumpOutPressure
        "
        [characteristics]="characteristics"
        [printPreview]="printPreview"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      ></authority-labs-check-water-characteristics-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="item.dieselShutdownPump.isApplicable"
    [attr.id]="item.dieselShutdownPump.title"
  >
    <mat-slide-toggle
      [color]="item.dieselShutdownPump.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="item.dieselShutdownPump.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        [class.error]="
          item.dieselShutdownPumpisApplicable &&
          !item.dieselShutdownPump.isPassed
        "
        >{{ item.dieselShutdownPump.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        item.dieselShutdownPump.isApplicable &&
        !item.dieselShutdownPump.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ item.dieselShutdownPump.title }}
    </span>
    <div
      class="cases"
      *ngIf="item.dieselShutdownPump.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.dieselShutdownPump.fuelTank"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.dieselShutdownPump.coolingSystem"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.dieselShutdownPump.batteriesCurrentVoltage"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.dieselShutdownPump.accumulatorsContacts"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.dieselShutdownPump.pressureDischarger"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.dieselShutdownPump.pumpSpeed"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.dieselShutdownPump.coolingWaterFlow"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="item.electricShutdownPump.isApplicable"
    [attr.id]="item.electricShutdownPump.title"
  >
    <mat-slide-toggle
      [color]="item.electricShutdownPump.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="item.electricShutdownPump.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        [class.error]="
          item.electricShutdownPump.isApplicable &&
          !item.electricShutdownPump.isPassed
        "
        >{{ item.electricShutdownPump.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        item.electricShutdownPump.isApplicable &&
        !item.electricShutdownPump.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ item.electricShutdownPump.title }}
    </span>
    <div
      class="cases"
      *ngIf="item.electricShutdownPump.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.electricShutdownPump.pumpRotation"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.electricShutdownPump.pumpWaterSupply"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="item.waterFlowTest.isApplicable"
    [attr.id]="item.waterFlowTest.title"
  >
    <mat-slide-toggle
      [color]="item.waterFlowTest.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="item.waterFlowTest.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        [class.error]="
          item.waterFlowTest.isApplicable && !item.waterFlowTest.isPassed
        "
        >{{ item.waterFlowTest.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        item.waterFlowTest.isApplicable && !item.waterFlowTest.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ item.waterFlowTest.title }}
    </span>
    <div
      class="cases"
      *ngIf="item.waterFlowTest.isApplicable; else notApplicable"
    >
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.waterFlowTest.waterFlowReservoir"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.waterFlowTest.waterFlowSuctionSide"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="item.waterFlowTest.waterFlowInstaller"
      ></authority-labs-check-case>
    </div>
  </section>
  <section
    class="check-cases"
    [class.border]="item.waterFlowData.isApplicable"
    [attr.id]="item.waterFlowData.title"
  >
    <mat-slide-toggle
      [color]="item.waterFlowData.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="item.waterFlowData.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        [class.error]="
          item.waterFlowData.isApplicable && !item.waterFlowData.isPassed
        "
        >{{ item.waterFlowData.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        item.waterFlowData.isApplicable && !item.waterFlowData.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ item.waterFlowData.title }}
    </span>
    <div
      class="cases"
      *ngIf="item.waterFlowData.isApplicable; else notApplicable"
    >
      <authority-labs-check-water-flow-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [waterFlowData]="item.waterFlowData"
      ></authority-labs-check-water-flow-case>
    </div>
  </section>
  <section class="actions" *ngIf="!(readonly || printPreview)">
    <button
      class="remove-btn"
      mat-raised-button
      aria-label="remove"
      [disabled]="data.pumps.length === 1"
      (click)="removeTest(ind)"
    >
      <span>הסר</span>
    </button>
    <button
      class="add-btn"
      mat-raised-button
      color="accent"
      aria-label="add"
      (click)="addTest()"
    >
      <span>הוסף בדיקה</span>
    </button>
  </section>
</ng-template>

<ng-template #notApplicable>
  <mat-radio-group disabled="true" class="print-preview" *ngIf="printPreview">
    <mat-radio-button checked="false">מתאים</mat-radio-button>
    <mat-radio-button checked="false">לא מתאים</mat-radio-button>
    <mat-radio-button value="true" checked="true">לא ישים</mat-radio-button>
  </mat-radio-group>
</ng-template>
